import React from 'react';
import { Shield, Lock, FileCheck, Award } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: Shield,
    text: 'Secure & Confidential'
  }, {
    icon: FileCheck,
    text: 'Compliance Focused'
  }, {
    icon: Award,
    text: 'Education First'
  }, {
    icon: Lock,
    text: 'Data Encrypted'
  }];
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-6 py-8 border-y border-slate-100 bg-slate-50/50" data-id="element-174">
      {badges.map((badge, index) => <div key={index} className="flex flex-col items-center justify-center text-center p-4" data-id="element-175">
          <badge.icon className="h-8 w-8 text-blue-600 mb-2" data-id="element-176" />
          <span className="text-sm font-medium text-slate-700" data-id="element-177">
            {badge.text}
          </span>
        </div>)}
    </div>;
}